import { format, parse } from 'date-fns';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { createAppointment } from '../../providers/appointments';
import { fetchUser } from '../../providers/auth';
import { fetchClinic } from '../../providers/clinics';
import { useTranslations } from '../../providers/i18n';
import LargeButton from '../LargeButton';
import Button from '../Button';
import Fields from './Fields';
import Professionals from './Professionals';

function BookingForm({ clinic_id }) {
    const [t, translationsLoaded] = useTranslations('booking-form');
    const [clinic, setClinic] = useState(null);
    const [user, setUser] = useState(null);
    const [booking, setBooking] = useState(false);
    const [specialtyFilter, setSpecialtyFilter] = useState('');
    // const [coupon, setCoupon] = useState(null);
    const [valid, setValid] = useState(false);
    const [total, setTotal] = useState(0);
    const [submitting, setSubmitting] = useState(false);

    const [fields, setFields] = useState({
        specialty_id: '',
        professional_id: '',
        date: format(new Date(), 'yyyy-MM-dd'),
        time: '',
        video: false,
        name: '',
    });

    const setFieldValue = (name, value) => {
        setFields((prev) => ({ ...prev, [name]: value }));
    };

    const cleanup = () => {
        setFieldValue('professional_id', '');
        setFieldValue('specialty_id', '');
        setFieldValue('name', '');
        fetchClinic(clinic_id).then(setClinic);
        // hasCoupon(clinic_id).then(setCoupon);
        setBooking(false);
        setTotal(0);
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        if (!submitting) {
            setSubmitting(true);
            if (fields.specialty_id && fields.professional_id && fields.date && fields.time && (!fields.other_patient || fields.name)) {
                try {
                    const date = parse(`${fields.date} ${fields.time}`, 'yyyy-MM-dd HH:mm', new Date()).toISOString();
                    const params = { ...fields, date };
                    delete params.time;
                    await createAppointment(params);
                    cleanup();
                    toast.success('Pedido submetido com sucesso!');
                } catch (e) {
                    console.error(e);
                    toast.error(e.response.data?.message || e.message);
                }
            }
            setSubmitting(false);
        }
    };

    useEffect(() => {
        fetchClinic(clinic_id).then(setClinic);
        fetchUser()
            .then(setUser)
            // .then(() => {
            //     hasCoupon(clinic_id).then(setCoupon);
            // })
            .catch(() => {});
    }, []);

    useEffect(() => {
        setFieldValue('user_id', user?.id);
    }, [user]);

    useEffect(() => {
        const specialty = clinic?.specialties.find(({ id }) => id == fields.specialty_id);
        setTotal(parseFloat(specialty?.price) || 0);
    }, [fields.specialty_id]);

    if (!clinic) return null;
    if (!translationsLoaded) return null;

    return (
        <form className="space-y-4" onSubmit={submitHandler}>
            {/* {coupon && <div className="px-4 py-2 text-lg font-medium text-center text-blue-700 bg-blue-100 border border-blue-300 rounded">Tem um cupão de {coupon}&euro; disponível</div>} */}

            <div className="mb-4 flex flex-col justify-between gap-2 border-b border-gray-200 pb-1 sm:flex-row">
                <h2 className="text-xl font-medium text-blue-700">{booking ? t('title-active') : t('title-idle')}</h2>
                <select
                    className="cursor-pointer border-none py-0 pl-0 text-right text-sm focus:ring-0"
                    value={specialtyFilter}
                    onChange={(e) => {
                        setSpecialtyFilter(e.target.value);
                    }}
                >
                    <option value="" className="text-left">
                        {t('all-specialties')}
                    </option>
                    {clinic?.specialties?.map(({ id, name }) => (
                        <option className="text-left" key={id} value={id}>
                            {name}
                        </option>
                    ))}
                </select>
            </div>

            <Professionals clinic={clinic} booking={booking} specialty={specialtyFilter} setFieldValue={setFieldValue} t={t} />

            {booking ? (
                <>
                    <Fields {...{ clinic, fields, setFieldValue, setValid, t }} />
                    {fields.specialty_id ? (
                        <div className="pt-4">
                            <h3 className="border-b-2 border-blue-600 pb-2 text-xl font-medium text-blue-600">{t('total')}</h3>
                            <div className="flex justify-between pt-4">
                                <div className="text-5xl font-semibold">{total.toFixed(2)}€</div>
                                <Button type="submit" disabled={!valid} className="min-w-[120px]" loading={submitting}>
                                    {t('action-active')}
                                </Button>
                            </div>
                        </div>
                    ) : null}
                </>
            ) : (
                <div className="pt-2">
                    <LargeButton
                        type="button"
                        onClick={() => {
                            user ? setBooking(true) : (window.location.href = `/login/?referrer=${encodeURIComponent(window.location.pathname)}`);
                        }}
                    >
                        {t('action-idle')}
                    </LargeButton>
                </div>
            )}
        </form>
    );
}

export default BookingForm;
